module.exports = "/_next/static/images/title-6153c66f94d5c725c23c8ff5412289ff.svg";